export const timeLoggerSourceCode = 'TL'

export const taskSourceCode = (
  projectIntegration?: Pick<ProjectIntegration, 'code'> | null,
): string => projectIntegration?.code ?? timeLoggerSourceCode
